// Pure bits of the Sales > Invoices nav badge (kept apart from the hook so node can test them).
export const parseCount = r => (r && r.count != null && Number.isFinite(Number(r.count)) ? Number(r.count) : null);
// Writes that can change the To-invoice worklist: invoice issue/dismiss/cancel, dispatch + delivery confirmations.
export const touchesWorklist = ep => /invoice|dispatch|delivery-events/.test(String(ep));
// perf-badge (dev saturation 2026-10-16): the badge poll. Every `ms` (60 s), skipped while the tab is hidden or no one is signed in
// (login page), and never overlapping (a slow answer is not stacked on); coming back to the tab loads once. start() returns stop().
export function makeBadgePoller(load, { ms = 60000, doc = typeof document !== 'undefined' ? document : null, hasToken = () => true, every = setInterval, cancel = clearInterval } = {}) {
  let inflight = false;
  const tick = () => {
    if (inflight || !hasToken() || (doc && doc.visibilityState === 'hidden')) return;
    inflight = true;
    Promise.resolve().then(load).catch(() => {}).finally(() => { inflight = false; });
  };
  const onVis = () => { if (!doc || doc.visibilityState !== 'hidden') tick(); };
  return {
    tick,
    start() {
      tick();
      const t = every(tick, ms);
      if (doc && doc.addEventListener) doc.addEventListener('visibilitychange', onVis);
      return () => { cancel(t); if (doc && doc.removeEventListener) doc.removeEventListener('visibilitychange', onVis); };
    },
  };
}
